import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Field } from "formik";

export default function InputRadio({
	id = null,
	name,
	label,
	radio_list,
	sx,
	size = "medium",
	show_label = false,
	required = false,
	disabled = false,
	on_change = null,
}) {
	return (
		<Field name={name}>
			{({ field }) => (
				<>
					{show_label && <FormLabel>{`${label}${required ? " *" : ""}`}</FormLabel>}

					<RadioGroup {...field} aria-labelledby={name} name={name} row>
						{radio_list.map((radio) => (
							<FormControlLabel
								id={id}
								disabled={disabled}
								key={radio.label}
								value={radio.value}
								onClick={(event) => {
									if (radio.onClick) {
										radio.onClick();
									}
									field.onChange(event);
									on_change?.(radio.value);
								}}
								control={radio.control ? radio.control : <Radio size={size} />}
								label={radio.label}
								sx={sx}
							/>
						))}
					</RadioGroup>
				</>
			)}
		</Field>
	);
}
